import {Box, Typography} from '@mui/material';
import {UserAccount} from '../../../__generated__/resolvers-types';
import ContactMessageList from '../../../components/contactMessageList/ContactMessageList';

export interface ContactMessagesProps {
  user: UserAccount | null | undefined;
}

export default function ContactMessages({user}: ContactMessagesProps) {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Contact Messages
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        View your recent contact messages and support requests.
        {user?.permissions?.includes('owner') && ' (Showing all messages as owner)'}
      </Typography>
      <ContactMessageList user={user} />
    </Box>
  );
}
